import {useState, useRef} from 'react';
import {useTheme} from './ThemeProvider';
import {clearCache} from '../utils/cache';

function Menu() {
    const [isOpen, setIsOpen] = useState(false);
    const {theme, toggleTheme} = useTheme();
    const menuRef = useRef<HTMLDivElement>(null);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleClearCache = () => {
        const count = clearCache();
        alert(`Cleared ${count} cached entries`);
        setIsOpen(false);
    };

    const handleThemeToggle = () => {
        toggleTheme();
        setIsOpen(false);
    };

    return (
        <div className="fixed top-2 right-2 z-50">
            <button
                id="menuToggle"
                type="button"
                aria-label="Menu"
                aria-expanded={isOpen}
                onClick={handleToggle}
                className="menu-button"
            >
                <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/>
                </svg>
            </button>

            {isOpen && (
                <>
                    <div
                        className="fixed inset-0"
                        onClick={() => setIsOpen(false)}
                    />
                    <div
                        ref={menuRef}
                        className="menu-dropdown"
                    >
                        <div className="py-1">
                            <button
                                type="button"
                                onClick={handleThemeToggle}
                                className="menu-item flex items-center gap-2"
                            >
                                <span>{theme === 'dark' ? '☀️' : '🌙'}</span>
                                <span>Switch to {theme === 'dark' ? 'light' : 'dark'} mode</span>
                            </button>
                            <button
                                type="button"
                                onClick={handleClearCache}
                                className="menu-item"
                            >
                                Clear Cache
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default Menu;
